import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const LogoutSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default LogoutSVG;
